<nb-card class="save-view-name-dialog">
  <nb-card-header>{{ 'KPI.SAVED_VIEWS.SAVE_DIALOG_TITLE' | translate }}</nb-card-header>
  <nb-card-body>
    <p class="text-muted mb-3">{{ 'KPI.SAVED_VIEWS.SAVE_DIALOG_PROMPT' | translate }}</p>
    <input
      nbInput
      fullWidth
      type="text"
      maxlength="80"
      [(ngModel)]="viewName"
      [placeholder]="'KPI.SAVED_VIEWS.NAME_PLACEHOLDER' | translate"
      (keyup.enter)="save()" />
  </nb-card-body>
  <nb-card-footer class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'KPI.SAVED_VIEWS.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      {{ 'KPI.SAVED_VIEWS.SAVE' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
